export const globalResources = [
  {
    "Key": "Sections",
    "fa-IR": "بخش ها",
    "en-US": "Sections"
  },
  {
    "Key": "SectionTitle",
    "fa-IR": "عنوان بخش",
    "en-US": "Section title"
  },
  {
    "Key": "ConfirmedUsers",
    "fa-IR": "کاربران دارای دسترسی",
    "en-US": "Confirmed users"
  },
  {
    "Key": "ConfirmedRoles",
    "fa-IR": "نقش های دارای دسترسی",
    "en-US": "Confirmed roles"
  },
  {
    "Key": "SectionName",
    "fa-IR": "نام بخش",
    "en-US": "Section name"
  },
  {
    "Key": "fa-IR",
    "fa-IR": "مقدار",
    "en-US": "fa-IR"
  },
  {
    "Key": "Attribute",
    "fa-IR": "مشخصه",
    "en-US": "Attribute"
  },
  {
    "Key": "ControlType",
    "fa-IR": "نوع کنترل",
    "en-US": "Control type"
  },
  {
    "Key": "Back",
    "fa-IR": "بازگشت",
    "en-US": "Back"
  },
  {
    "Key": "AttributeGroup",
    "fa-IR": "گروه مشخصه",
    "en-US": "Attribute group"
  },
  {
    "Key": "ShowInAdvancedFiltering",
    "fa-IR": "نمایش در جستجو",
    "en-US": "Show in Advanced filtering"
  },
  {
    "Key": "ProductGroups",
    "fa-IR": "گروه محصولات",
    "en-US": "Product groups"
  },
  {
    "Key": "AttributeOptions",
    "fa-IR": "مقادیر مشخصه",
    "en-US": "Attribute options"
  },
  {
    "Key": "DisplayType",
    "fa-IR": "نوع نمایش",
    "en-US": "Display type"
  },
  {
    "Key": "AttributeFormNote_1",
    "fa-IR": "مشخصاتی که از نوع کنترل متنی باشند، امکان استفاده در جستجوی پیشرفته را ندارند.",
    "en-US": "Text attribute can not be used in Advanced filtering"
  },
  {
    "Key": "AccountOwnerName",
    "fa-IR": "نام دارنده حساب",
    "en-US": "Account owner name"
  },
  {
    "Key": "BankName",
    "fa-IR": "نام بانک",
    "en-US": "Bank name"
  },
  {
    "Key": "AccountNumber",
    "fa-IR": "شماره حساب",
    "en-US": "Account number"
  },
  {
    "Key": "CardNumber",
    "fa-IR": "شماره کارت",
    "en-US": "Card number"
  },
  {
    "Key": "MakeInactive",
    "fa-IR": "غیر فعال سازی",
    "en-US": "Make inactive"
  },
  {
    "Key": "ApplyToEntireCart",
    "fa-IR": "اعمال بر روی کل سبد خرید",
    "en-US": "Apply To Entire Cart"
  },
  {
    "Key": "OwnerName",
    "fa-IR": "دارنده حساب",
    "en-US": "Account owner"
  },
  {
    "Key": "IsEnabled",
    "fa-IR": "وضعیت",
    "en-US": "Is enabled"
  },
  {
    "Key": "Username",
    "fa-IR": "نام کاربری",
    "en-US": "Username"
  },
  {
    "Key": "Password",
    "fa-IR": "رمز عبور",
    "en-US": "Password"
  },
  {
    "Key": "TerminalId",
    "fa-IR": "شماره ترمینال ",
    "en-US": "Terminal id"
  },
  {
    "Key": "PrivateCode",
    "fa-IR": "کد خصوصی",
    "en-US": "Private code"
  },
  {
    "Key": "MerchantID",
    "fa-IR": "شماره مشتری",
    "en-US": "Merchant id"
  },
  {
    "Key": "Dashboard",
    "fa-IR": "پنل مدیریتی فروشگاه",
    "en-US": "Dashboard"
  },
  {
    "Key": "Welcome",
    "fa-IR": "خوش آمدید",
    "en-US": "Welcome"
  },
  {
    "Key": "CommentStatus",
    "fa-IR": "وضعیت نظر",
    "en-US": "Comment status"
  },
  {
    "Key": "RegisteredList",
    "fa-IR": "لیست موارد ثبت شده",
    "en-US": "Registered list"
  },
  {
    "Key": "Blocked",
    "fa-IR": "تایید نشده",
    "en-US": "Blocked"
  },
  {
    "Key": "Author",
    "fa-IR": "نویسنده",
    "en-US": "Author"
  },
  {
    "Key": "Body",
    "fa-IR": "متن نظر",
    "en-US": "Body"
  },
  {
    "Key": "VoteCount",
    "fa-IR": "تعداد رای",
    "en-US": "Vote count"
  },
  {
    "Key": "IsApproved",
    "fa-IR": "وضعیت تایید",
    "en-US": "Is approved"
  },
  {
    "Key": "Approve",
    "fa-IR": "تایید",
    "en-US": "Approve selected records"
  },
  {
    "Key": "Block",
    "fa-IR": "عدم تایید",
    "en-US": "Block selected records"
  },
  {
    "Key": "ProductTitle",
    "fa-IR": "عنوان محصول",
    "en-US": "Product title"
  },
  {
    "Key": "Tax",
    "fa-IR": "درصد مالیات",
    "en-US": "Tax"
  },
  {
    "Key": "RegisterSMSBody",
    "fa-IR": "متن SMS ثبت نام",
    "en-US": "Register SMS body"
  },
  {
    "Key": "CheckoutSMSBody",
    "fa-IR": "متن SMS ثبت سفارش",
    "en-US": "Checkout SMS body"
  },
  {
    "Key": "SuccessfulPaySMSBody",
    "fa-IR": "متن SMS پرداخت موفق",
    "en-US": "Successful pay sms body"
  },
  {
    "Key": "FooterTelephone",
    "fa-IR": "تلفن قسمت فوتر",
    "en-US": "Footer telephone"
  },
  {
    "Key": "FooterEmail",
    "fa-IR": "ایمیل قسمت فوتر",
    "en-US": "Footer email"
  },
  {
    "Key": "Rules",
    "fa-IR": "متن قوانین فروشگاه",
    "en-US": "Rules"
  },
  {
    "Key": "From",
    "fa-IR": "از",
    "en-US": "From"
  },
  {
    "Key": "To",
    "fa-IR": "تا",
    "en-US": "To"
  },
  {
    "Key": "Code",
    "fa-IR": "کد",
    "en-US": "Code"
  },
  {
    "Key": "ValidDate",
    "fa-IR": "تاریخ اعتبار",
    "en-US": "Valid date"
  },
  {
    "Key": "DiscountAmount",
    "fa-IR": "مقدار تخفیف",
    "en-US": "Discount amount"
  },
  {
    "Key": "FixedPriceRial",
    "fa-IR": "ریـالی",
    "en-US": "$"
  },
  {
    "Key": "Percentage",
    "fa-IR": "درصدی",
    "en-US": "Percentage"
  },
  {
    "Key": "MinOrderAmount",
    "fa-IR": "کف خرید",
    "en-US": "Min order amount"
  },
  {
    "Key": "AllowedUseCount",
    "fa-IR": "تعداد مجاز قابل استفاده",
    "en-US": "Allowed use count"
  },
  {
    "Key": "IsPublic",
    "fa-IR": "آیا کد عمومی است؟",
    "en-US": "Is public"
  },
  {
    "Key": "CodeStatus",
    "fa-IR": "وضعیت",
    "en-US": "Code status"
  },
  {
    "Key": "UsedCount",
    "fa-IR": "تعداد استفاده شده",
    "en-US": "Used count"
  },
  {
    "Key": "BuyerName",
    "fa-IR": "نام مشتری",
    "en-US": "Buyer name"
  },
  {
    "Key": "BuyerPhone",
    "fa-IR": "تلفن",
    "en-US": "Buyer phone"
  },
  {
    "Key": "BuyerEmail",
    "fa-IR": "ایمیل",
    "en-US": "Buyer email"
  },
  {
    "Key": "BuyerMobile",
    "fa-IR": "موبایل",
    "en-US": "Buyer mobile"
  },
  {
    "Key": "BuyerPostalCode",
    "fa-IR": "کد پستی",
    "en-US": "Buyer postal code"
  },
  {
    "Key": "BuyerAddress",
    "fa-IR": "آدرس",
    "en-US": "Buyer address"
  },
  {
    "Key": "ExportExcel",
    "fa-IR": "خروجی اکسل",
    "en-US": "Export excel"
  },
  {
    "Key": "ProductGroup",
    "fa-IR": "گروه محصول",
    "en-US": "Product group"
  },
  {
    "Key": "Product",
    "fa-IR": "محصول",
    "en-US": "Product"
  },
  {
    "Key": "Role",
    "fa-IR": "نقش کاربران",
    "en-US": "Role"
  },
  {
    "Key": "BuyDate",
    "fa-IR": "تاریخ خرید",
    "en-US": "Buy date"
  },
  {
    "Key": "BuyCount",
    "fa-IR": "تعداد خرید",
    "en-US": "Buy count"
  },
  {
    "Key": "MinBuyCount",
    "fa-IR": "حداقل تعداد خرید",
    "en-US": "Min buy count"
  },
  {
    "Key": "MaxBuyCount",
    "fa-IR": "حداکثر تعداد خرید",
    "en-US": "Max buy count"
  },
  {
    "Key": "ValidityStartDate",
    "fa-IR": "شروع تاریخ اعتبار",
    "en-US": "Validity start date"
  },
  {
    "Key": "ValidityEndDate",
    "fa-IR": "پایان تاریخ اعتبار",
    "en-US": "Validity end date"
  },
  {
    "Key": "InvalidDate",
    "fa-IR": "تاریخ نامعتبر است",
    "en-US": "Invalid date"
  },
  {
    "Key": "AllProductGroups",
    "fa-IR": "تمام گروه ها",
    "en-US": "All product groups"
  },
  {
    "Key": "AllProducts",
    "fa-IR": "تمام محصولات",
    "en-US": "All products"
  },
  {
    "Key": "AllRoles",
    "fa-IR": "تمام نقش ها",
    "en-US": "All roles"
  },
  {
    "Key": "Link",
    "fa-IR": "لینک",
    "en-US": "Link"
  },
  {
    "Key": "LinkPlaceholder",
    "fa-IR": "http://www.example.com",
    "en-US": "http://www.example.com"
  },
  {
    "Key": "MetaKeywords",
    "fa-IR": "متا تگ کلمات کلیدی",
    "en-US": "Meta keywords"
  },
  {
    "Key": "MetaDescription",
    "fa-IR": "متا تگ توضیحات",
    "en-US": "Meta description"
  },
  {
    "Key": "Status",
    "fa-IR": "وضعیت",
    "en-US": "Status"
  },
  {
    "Key": "Quantity",
    "fa-IR": "تعداد",
    "en-US": "Quantity"
  },
  {
    "Key": "TrackingCode",
    "fa-IR": "کد رهگیری",
    "en-US": "Tracking code"
  },
  {
    "Key": "Suppliers",
    "fa-IR": "نمایندگان",
    "en-US": "Suppliers"
  },
  {
    "Key": "Name",
    "fa-IR": "نام",
    "en-US": "Name"
  },
  {
    "Key": "Phone",
    "fa-IR": "تلفن",
    "en-US": "Phone"
  },
  {
    "Key": "MobileNumber",
    "fa-IR": "شماره همراه",
    "en-US": "Mobile number"
  },
  {
    "Key": "Email",
    "fa-IR": "ایمیل",
    "en-US": "Email"
  },
  {
    "Key": "Fax",
    "fa-IR": "فکس",
    "en-US": "Fax"
  },
  {
    "Key": "PostalCode",
    "fa-IR": "کد پستی",
    "en-US": "Postal code"
  },
  {
    "Key": "Address",
    "fa-IR": "آدرس",
    "en-US": "Address"
  },
  {
    "Key": "State",
    "fa-IR": "استان",
    "en-US": "State"
  },
  {
    "Key": "City",
    "fa-IR": "شهر",
    "en-US": "City"
  },
  {
    "Key": "RegisterDate",
    "fa-IR": "تاریخ ثبت",
    "en-US": "Register date"
  },
  {
    "Key": "Picture",
    "fa-IR": "تصویر",
    "en-US": "Picture"
  },
  {
    "Key": "ProductUnitPrice",
    "fa-IR": "قیمت واحد محصول",
    "en-US": "Product unit price"
  },
  {
    "Key": "UserDescription",
    "fa-IR": "توضیحات کاربر",
    "en-US": "User description"
  },
  {
    "Key": "PaymentDate",
    "fa-IR": "تاریخ پرداخت",
    "en-US": "Payment date"
  },
  {
    "Key": "BasketTotalPrice",
    "fa-IR": "جمع سبد خرید",
    "en-US": "Basket total price"
  },
  {
    "Key": "Discount",
    "fa-IR": "تخفیف",
    "en-US": "Discount"
  },
  {
    "Key": "PostalPrice",
    "fa-IR": "هزینه پستی",
    "en-US": "Postal price"
  },
  {
    "Key": "PaidPrice",
    "fa-IR": "مبلغ پرداخت شده",
    "en-US": "Paid price"
  },
  {
    "Key": "PostalMethod",
    "fa-IR": "روش ارسال",
    "en-US": "Postal method"
  },
  {
    "Key": "PaymentMethod",
    "fa-IR": "روش پرداخت",
    "en-US": "Payment method"
  },
  {
    "Key": "SentDate",
    "fa-IR": "تاریخ ارسال کالا",
    "en-US": "Sent date"
  },
  {
    "Key": "ReceivedDate",
    "fa-IR": "تاریخ دریافت کالا",
    "en-US": "Received date"
  },
  {
    "Key": "RunningSettle",
    "fa-IR": "اجرای کد Settle",
    "en-US": "Running settle"
  },
  {
    "Key": "PaymentStatus",
    "fa-IR": "وضعیت پرداخت",
    "en-US": "Payment status"
  },
  {
    "Key": "OrderStatus",
    "fa-IR": "وضعیت سفارش",
    "en-US": "Order status"
  },
  {
    "Key": "Description",
    "fa-IR": "شرح",
    "en-US": "Description"
  },
  {
    "Key": "PaymentInformation",
    "fa-IR": "اطلاعات پرداخت",
    "en-US": "Payment information"
  },
  {
    "Key": "RefIdLabel",
    "fa-IR": "کد مرجع",
    "en-US": "Ref id label"
  },
  {
    "Key": "PayOrderId",
    "fa-IR": "شماره درخواست",
    "en-US": "Pay order id"
  },
  {
    "Key": "SaleReferenceId",
    "fa-IR": "کد مرجع تراکنش خرید",
    "en-US": "Sale reference id"
  },
  {
    "Key": "LastFourCardNumber",
    "fa-IR": "چهار شماره آخر کارت",
    "en-US": "Last four card number"
  },
  {
    "Key": "CustomerInfo",
    "fa-IR": "اطلاعات مشتری",
    "en-US": "Customer info"
  },
  {
    "Key": "BasketContent",
    "fa-IR": "محتویات سبد",
    "en-US": "Basket content"
  },
  {
    "Key": "OrderInfo",
    "fa-IR": "اطلاعات سفارش",
    "en-US": "Order info"
  },
  {
    "Key": "BuyerState",
    "fa-IR": "استان",
    "en-US": "Buyer state"
  },
  {
    "Key": "BuyerCity",
    "fa-IR": "شهر",
    "en-US": "Buyer city"
  },
  {
    "Key": "PriceUnit",
    "fa-IR": "قیمت واحد",
    "en-US": "Price unit"
  },
  {
    "Key": "TotalPrice",
    "fa-IR": "جمع سبد خرید",
    "en-US": "Total price"
  },
  {
    "Key": "All",
    "fa-IR": "همه",
    "en-US": "All"
  },
  {
    "Key": "ManagementCities",
    "fa-IR": "مدیریت شهرها",
    "en-US": "Management cities"
  },
  {
    "Key": "AllCities",
    "fa-IR": "تمام شهرها",
    "en-US": "All cities"
  },
  {
    "Key": "Price",
    "fa-IR": "قیمت",
    "en-US": "Price"
  },
  {
    "Key": "Curency",
    "fa-IR": "ریـال",
    "en-US": "$"
  },
  {
    "Key": "PriceCurency",
    "fa-IR": "قیمت (ریـال)",
    "en-US": "Price ($)"
  },
  {
    "Key": "MinPrice",
    "fa-IR": "کف خرید",
    "en-US": "Min price"
  },
  {
    "Key": "ManagementPrices",
    "fa-IR": "مدیریت هزینه",
    "en-US": "Management prices"
  },
  {
    "Key": "ManagementMinPrice",
    "fa-IR": "مدیریت کف خرید جهت فعال شدن ارسال رایگان",
    "en-US": "Management min price"
  },
  {
    "Key": "HelpNoteTitle",
    "fa-IR": "مدیر گرامی، لطفا به نکات زیر توجه نمایید",
    "en-US": "Help note title"
  },
  {
    "Key": "HelpNoteLine1",
    "fa-IR": "در صورتی که تمایل دارید از قابلیت کف خرید برای فعال/غیر فعال سازی خودکار گزینه ارسال رایگان، با توجه به کف خرید تعیین شده استفاده نمایید، بایستی گزینه ارسال رایگان را در فرم زیر فعال باشد.",
    "en-US": "Help note line1"
  },
  {
    "Key": "HelpNoteLine2",
    "fa-IR": "در صورت غیر فعال بودن گزینه ارسال رایگان در فرم زیر، گزینه های تعریف شده در فرم کف خرید در روال خرید سایت نادیده گرفته خواهند شد.",
    "en-US": "Help note line2"
  },
  {
    "Key": "HelpNoteLine3",
    "fa-IR": "در صورت تعریف کف خرید، گزینه ارسال رایگان تنها زمانی در دسترس خواهد بود که کف خرید مشتری به مرز مقدار تعریف شده رسیده باشد.",
    "en-US": "Help note line3"
  },
  {
    "Key": "Add",
    "fa-IR": "افزودن",
    "en-US": "Add"
  },
  {
    "Key": "Delete",
    "fa-IR": "حذف",
    "en-US": "Delete"
  },
  {
    "Key": "Parent",
    "fa-IR": "سر گروه",
    "en-US": "Parent"
  },
  {
    "Key": "YouShouldSelectAGroup",
    "fa-IR": "شما باید ابتدا گروه را انتخاب کنید",
    "en-US": "You should select a group"
  },
  {
    "Key": "ThisGroupHaveChildren",
    "fa-IR": "این گروه شامل زیر گروه است",
    "en-US": "This group have children"
  },
  {
    "Key": "ThisGroupHaveProduct",
    "fa-IR": "این گروه شامل محصول است",
    "en-US": "This group have product"
  },
  {
    "Key": "MetaTitle",
    "fa-IR": "متا تگ عنوان",
    "en-US": "Meta title"
  },
  {
    "Key": "HowToAdd",
    "fa-IR": "برای افزودن گروه، ابتدا بر روی گروه والد مورد نظر در درخت پایین کلیک و بعد از بارگذاری کامل صفحه، دکمه \"افزودن\" را زده و اطلاعات مربوط به گروه را وارد کنید و دکمه \"ثبت\" را بزنید.",
    "en-US": "How to add"
  },
  {
    "Key": "HowToDelete",
    "fa-IR": "برای حذف یک گروه، ابتدا بر روی گروه مورد نظر در درخت پایین کلیک و بعد از بارگذاری کامل صفحه، دکمه \"حذف\" را زده و در پیغام به نمایش آمده، دکمه \"تایید\" را بزنید.",
    "en-US": "How to delete"
  },
  {
    "Key": "HowToEdit",
    "fa-IR": "برای ویرایش یک گروه، ابتدا بر روی گروه مورد نظر در درخت پایین کلیک و بعد از بارگذاری کامل صفحه، اطلاعات مربوط به گروه را ویرایش کنید و دکمه \"ثبت\" را بزنید.",
    "en-US": "How to edit"
  },
  {
    "Key": "ImageSizeNote",
    "fa-IR": "برای داشتن بهترین خروجی در هنگام نمایش تصاویر در سایت، بایستی اندازه عکس مطابق یا اندازه درج شده باشد.",
    "en-US": "Image size note"
  },
  {
    "Key": "MegaMenuColNumber",
    "fa-IR": "ستون در مگا منو",
    "en-US": "Mega menu col number"
  },
  {
    "Key": "BaseInfo",
    "fa-IR": "اطلاعات پایه",
    "en-US": "Base info"
  },
  {
    "Key": "OtherInfo",
    "fa-IR": "سایر اطلاعات",
    "en-US": "Other info"
  },
  {
    "Key": "Seo",
    "fa-IR": "سئو",
    "en-US": "Seo"
  },
  {
    "Key": "SecondTitle",
    "fa-IR": "عنوان دوم",
    "en-US": "Second title"
  },
  {
    "Key": "ProductHasVariants",
    "fa-IR": "محصول دارای انواع دیگر است",
    "en-US": "Product has variants"
  },
  {
    "Key": "StockCountAlert",
    "fa-IR": "نقطه سفارش",
    "en-US": "Stock count alert"
  },
  {
    "Key": "MinOrderCount",
    "fa-IR": "حداقل تعداد سفارش",
    "en-US": "Min order count"
  },
  {
    "Key": "MaxOrderCount",
    "fa-IR": "حداکثر تعداد سفارش",
    "en-US": "Max order count"
  },
  {
    "Key": "OrderCountStep",
    "fa-IR": "گام افزایشی سفارش",
    "en-US": "Order count step"
  },
  {
    "Key": "AttributeOptionValues",
    "fa-IR": "مقادیر درج شده",
    "en-US": "Attribute option values"
  },
  {
    "Key": "Note#1",
    "fa-IR": "امکان ثبت دو مشخصه یکسان (در تب مشخصات) وجود ندارد.",
    "en-US": "Note#1"
  },
  {
    "Key": "Note#2",
    "fa-IR": "در صورتی که در تب 'ترکیب محصولات' اطلاعاتی ثبت گردد، مشخصه متناظر آن در تب 'مشخصات' غیر قابل حذف است.",
    "en-US": "Note#2"
  },
  {
    "Key": "AddNewFolder",
    "fa-IR": "افزودن پوشه جدید",
    "en-US": "Add new folder"
  },
  {
    "Key": "PleaseUseEnglishNameOnly",
    "fa-IR": "لطفا از حروف انگلیسی برای نام پوشه استفاده نمایید",
    "en-US": "Please use english name only"
  },
  {
    "Key": "FolderName",
    "fa-IR": "نام پوشه",
    "en-US": "Folder name"
  },
  {
    "Key": "DownloadLimitCount",
    "fa-IR": "محدودیت تعداد دانلود",
    "en-US": "Download limit count"
  },
  {
    "Key": "UploadNewFile",
    "fa-IR": "آپلود فایل جدید",
    "en-US": "Upload new file"
  },
  {
    "Key": "SupportedFiles",
    "fa-IR": "فایل های معتبر",
    "en-US": "Supported files"
  },
  {
    "Key": "SelectingFolder",
    "fa-IR": "انتخاب پوشه",
    "en-US": "Selecting folder"
  },
  {
    "Key": "File",
    "fa-IR": "فایل",
    "en-US": "File"
  },
  {
    "Key": "SelectingFile",
    "fa-IR": "انتخاب فایل",
    "en-US": "Selecting file"
  },
  {
    "Key": "CreateFolder",
    "fa-IR": "ایجاد پوشه",
    "en-US": "Create folder"
  },
  {
    "Key": "Send",
    "fa-IR": "ارسال",
    "en-US": "Send"
  },
  {
    "Key": "NoFileSelected",
    "fa-IR": "هیچ فایلی انتخاب نشده است",
    "en-US": "No file selected"
  },
  {
    "Key": "InvalidFileSelected",
    "fa-IR": "فایل نامعتبر است",
    "en-US": "Invalid file selected"
  },
  {
    "Key": "FolderAlreadyExist",
    "fa-IR": "اپوشه ای با همین نام موجود است",
    "en-US": "Folder already exist"
  },
  {
    "Key": "FileAddress",
    "fa-IR": "فایل",
    "en-US": "File address"
  },
  {
    "Key": "Group",
    "fa-IR": "گروه",
    "en-US": "Group"
  },
  {
    "Key": "AddNewGroup",
    "fa-IR": "افزودن گروه جدید",
    "en-US": "Add new group"
  },
  {
    "Key": "Normal",
    "fa-IR": "عادی",
    "en-US": "Normal"
  },
  {
    "Key": "Partner",
    "fa-IR": "همکار",
    "en-US": "Partner"
  },
  {
    "Key": "OldPrice",
    "fa-IR": "قیمت قدیم",
    "en-US": "Old price"
  },
  {
    "Key": "NewPrice",
    "fa-IR": "قیمت جدید",
    "en-US": "New price"
  },
  {
    "Key": "Currency",
    "fa-IR": "ریـال",
    "en-US": "Currency"
  },
  {
    "Key": "ProductCode",
    "fa-IR": "کد حسابداری محصول",
    "en-US": "Product code"
  },
  {
    "Key": "ProductBoxes",
    "fa-IR": "باکس های محصول",
    "en-US": "Product boxes"
  },
  {
    "Key": "SpecialOffer",
    "fa-IR": "پیشنهاد ویژه",
    "en-US": "Special offer"
  },
  {
    "Key": "AddNewProduct",
    "fa-IR": "محصول جدید",
    "en-US": "New product"
  },
  {
    "Key": "StockCount",
    "fa-IR": "تعداد موجودی",
    "en-US": "Stock count"
  },
  {
    "Key": "Keywords",
    "fa-IR": "کلمات کلیدی",
    "en-US": "Keywords"
  },
  {
    "Key": "Summary",
    "fa-IR": "خلاصه",
    "en-US": "Summary"
  },
  {
    "Key": "ReleaseDate",
    "fa-IR": "تاریخ انتشار",
    "en-US": "Release date"
  },
  {
    "Key": "ExpirationDate",
    "fa-IR": "تاریخ انقضا",
    "en-US": "Expiration date"
  },
  {
    "Key": "FirstBox",
    "fa-IR": "باکس اول",
    "en-US": "First box"
  },
  {
    "Key": "SecondBox",
    "fa-IR": "باکس دوم",
    "en-US": "Second box"
  },
  {
    "Key": "ThirdBox",
    "fa-IR": "باکس سوم",
    "en-US": "Third box"
  },
  {
    "Key": "Review",
    "fa-IR": "نقد و بررسی",
    "en-US": "Review"
  },
  {
    "Key": "Weight",
    "fa-IR": "وزن",
    "en-US": "Weight"
  },
  {
    "Key": "VisitedCount",
    "fa-IR": "تعداد بازدید",
    "en-US": "Visited count"
  },
  {
    "Key": "YouShouldSelectMinimumOneGroup",
    "fa-IR": "شما باید حداقل یک گروه را انتخاب نمایید",
    "en-US": "You should select at least one group"
  },
  {
    "Key": "IsArchived",
    "fa-IR": "آرشیو شده",
    "en-US": "Is archived"
  },
  {
    "Key": "AdminApproved",
    "fa-IR": "تایید شده",
    "en-US": "Approved"
  },
  {
    "Key": "IsSpecialOffer",
    "fa-IR": "پیشنهاد ویژه",
    "en-US": "Is special offer"
  },
  {
    "Key": "HasTax",
    "fa-IR": "مشمول مالیات",
    "en-US": "Has tax"
  },
  {
    "Key": "ProductInfo",
    "fa-IR": "اطلاعات محصول",
    "en-US": "Product info."
  },
  {
    "Key": "ProductGallery",
    "fa-IR": "گالری تصاویر محصول",
    "en-US": "Product gallery"
  },
  {
    "Key": "RelatedProduct",
    "fa-IR": "محصولات مرتبط",
    "en-US": "Related product"
  },
  {
    "Key": "SimilarProduct",
    "fa-IR": "محصولات مشابه",
    "en-US": "Similar product"
  },
  {
    "Key": "Attributes",
    "fa-IR": "مشخصات",
    "en-US": "Attributes"
  },
  {
    "Key": "RelatedFiles",
    "fa-IR": "فایل های مرتبط",
    "en-US": "Related files"
  },
  {
    "Key": "ProductVariants",
    "fa-IR": "انواع دیگر محصول",
    "en-US": "Product variants"
  },
  {
    "Key": "CustomProducts",
    "fa-IR": "ترکیب محصول",
    "en-US": "Custom products"
  },
  {
    "Key": "SendNotification",
    "fa-IR": "ارسال نوتیفیکیشن",
    "en-US": "Send notification"
  },
  {
    "Key": "SuccessfulSends",
    "fa-IR": "ارسال های موفق",
    "en-US": "Successful sends"
  },
  {
    "Key": "UnsuccessfulSends",
    "fa-IR": "ارسال های ناموفق",
    "en-US": "Unsuccessful sends"
  },
  {
    "Key": "Update",
    "fa-IR": "بروزرسانی",
    "en-US": "Update"
  },
  {
    "Key": "TotalSentCount",
    "fa-IR": "مجموع ارسال ها",
    "en-US": "Total sent count"
  },
  {
    "Key": "SuccessfulCount",
    "fa-IR": "ارسال های موفق",
    "en-US": "Successful count"
  },
  {
    "Key": "PushNotificationTitle",
    "fa-IR": "عنوان نوتیفیکیشن ارسالی",
    "en-US": "Push notification title"
  },
  {
    "Key": "PushNotificationBody",
    "fa-IR": "متن نوتیفیکیشن ارسالی",
    "en-US": "Push notification body"
  },
  {
    "Key": "EmailSubject",
    "fa-IR": "موضوع ایمیل",
    "en-US": "Email subject"
  },
  {
    "Key": "EmailBody",
    "fa-IR": "متن ایمیل",
    "en-US": "Email body"
  },
  {
    "Key": "FullName",
    "fa-IR": "نام و نام خانوادگی",
    "en-US": "Full name"
  },
  {
    "Key": "CallNumber",
    "fa-IR": "شماره تماس",
    "en-US": "Call number"
  },
  {
    "Key": "TotalQuantity",
    "fa-IR": "تعداد کل خریداری شده",
    "en-US": "Total quantity"
  },
  {
    "Key": "TotalPaidPrice",
    "fa-IR": "مبلغ کل پرداخت  شده (ریـال)",
    "en-US": "Total paid price"
  },
  {
    "Key": "ProductUnitPriceTaxIncluded",
    "fa-IR": "قیمت واحد محصول با احتساب مالیات (ریـال)",
    "en-US": "Product unit price tax included"
  },
  {
    "Key": "TotalPaidPriceTaxIncluded",
    "fa-IR": "مبلغ کل پرداخت  شده با احتساب مالیات (ریـال)",
    "en-US": "Total paid price tax included"
  },
  {
    "Key": "SaleReporting",
    "fa-IR": "گزارش فروش",
    "en-US": "Sale reporting"
  },
  {
    "Key": "SelectOne",
    "fa-IR": "انتخاب یک مورد",
    "en-US": "Select one"
  },
  {
    "Key": "NameFamily",
    "fa-IR": "نام کاربر",
    "en-US": "Name family"
  },
  {
    "Key": "NoRecordFound",
    "fa-IR": "رکوردی ثبت نشده است",
    "en-US": "No record found"
  },
  {
    "Key": "Mobile",
    "fa-IR": "موبایل",
    "en-US": "Mobile"
  },
  {
    "Key": "Catalog",
    "fa-IR": "کاتالوگ",
    "en-US": "Catalog"
  },
  {
    "Key": "Products",
    "fa-IR": "محصولات",
    "en-US": "Products"
  },
  {
    "Key": "ProductCatalog",
    "fa-IR": "محصولات",
    "en-US": "Product catalog"
  },
  {
    "Key": "BulkEditing",
    "fa-IR": "ویرایش دسته ای",
    "en-US": "Bulk editing"
  },
  {
    "Key": "StockCountReport",
    "fa-IR": "گزارش کاهش موجودی",
    "en-US": "Stock count report"
  },
  {
    "Key": "AttributeCatalog",
    "fa-IR": "مشخصه ها",
    "en-US": "Attribute catalog"
  },
  {
    "Key": "AttributeGroups",
    "fa-IR": "گروه مشخصه ها",
    "en-US": "Attribute groups"
  },
  {
    "Key": "Configuration",
    "fa-IR": "پیکربندی",
    "en-US": "Configuration"
  },
  {
    "Key": "Configs",
    "fa-IR": "تنظیمات عمومی",
    "en-US": "Configs"
  },
  {
    "Key": "PostalMethods",
    "fa-IR": "روش های ارسال",
    "en-US": "Postal methods"
  },
  {
    "Key": "PaymentMethods",
    "fa-IR": "روش های پرداخت",
    "en-US": "Payment methods"
  },
  {
    "Key": "BankPorts",
    "fa-IR": "درگاه های بانکی",
    "en-US": "Bank ports"
  },
  {
    "Key": "BankAccounts",
    "fa-IR": "حساب های بانکی",
    "en-US": "Bank accounts"
  },
  {
    "Key": "Orders",
    "fa-IR": "سفارشات",
    "en-US": "Orders"
  },
  {
    "Key": "Customers",
    "fa-IR": "لیست مشتریان",
    "en-US": "Customers"
  },
  {
    "Key": "SpecialOrders",
    "fa-IR": "سفارشات خاص",
    "en-US": "Special orders"
  },
  {
    "Key": "Content",
    "fa-IR": "محتوا",
    "en-US": "Content"
  },
  {
    "Key": "Comments",
    "fa-IR": "نظرات کاربران",
    "en-US": "Comments"
  },
  {
    "Key": "Discounts",
    "fa-IR": "تخفیفات",
    "en-US": "Discounts"
  },
  {
    "Key": "PhotoSlider",
    "fa-IR": "اسلایدر",
    "en-US": "Photo slider"
  },
  {
    "Key": "PushNotification",
    "fa-IR": "پوش نوتیفیکیشن",
    "en-US": "Push notification"
  },
  {
    "Key": "PushNotificationReport",
    "fa-IR": "گزارش ارسال",
    "en-US": "Push notification report"
  },
  {
    "Key": "ReqMoreInfo",
    "fa-IR": "درخواست های ثبت شده",
    "en-US": "Req more info"
  },
  {
    "Key": "OrderDetails",
    "fa-IR": "لیست کالاهای سفارش",
    "en-US": "Order details"
  },
  {
    "Key": "Coupons",
    "fa-IR": "کدهای تخفیف",
    "en-US": "Coupons"
  },
  {
    "Key": "DisplayOrder",
    "fa-IR": "ترتیب نمایش",
    "en-US": "Display order"
  },
  {
    "Key": "Title",
    "fa-IR": "عنوان",
    "en-US": "Title"
  },
  {
    "Key": "CreatedDate",
    "fa-IR": "تاریخ ثبت",
    "en-US": "Created date"
  },
  {
    "Key": "Search",
    "fa-IR": "جستجو",
    "en-US": "Search"
  },
  {
    "Key": "SelectedRecords",
    "fa-IR": "موارد انتخاب شده",
    "en-US": "Selected records"
  },
  {
    "Key": "RecordPerPage",
    "fa-IR": "تعداد نمایش",
    "en-US": "Record per page"
  },
  {
    "Key": "SpecialOffers",
    "fa-IR": "پیشنهادات ویژه",
    "en-US": "Special offers"
  },
  {
    "Key": "Approve",
    "fa-IR": "تایید",
    "en-US": "Approve"
  },
  {
    "Key": "Unapprove",
    "fa-IR": "عدم تایید",
    "en-US": "Unapprove"
  },
  {
    "Key": "Archive",
    "fa-IR": "آرشیو",
    "en-US": "Archive"
  },
  {
    "Key": "Unarchive",
    "fa-IR": "عدم آرشیو",
    "en-US": "Unarchive"
  },
  {
    "Key": "Unapproved",
    "fa-IR": "تایید نشده",
    "en-US": "Unapproved"
  },
  {
    "Key": "Approved",
    "fa-IR": "تایید شده",
    "en-US": "Approved"
  },
  {
    "Key": "RegisterForm",
    "fa-IR": "فرم ثبت",
    "en-US": "Register"
  },
  {
    "Key": "Submit",
    "fa-IR": "ثبت",
    "en-US": "Submit"
  },
  {
    "Key": "Cancel",
    "fa-IR": "انصراف",
    "en-US": "Cancel"
  },
  {
    "Key": "SweetSize",
    "fa-IR": "سایز مناسب <small>(عرضxارتفاع)</small>",
    "en-US": "Sweet size"
  },
  {
    "Key": "Pixel",
    "fa-IR": "پیکسل",
    "en-US": "Pixel"
  },
  {
    "Key": "PushNotification_Note#1",
    "fa-IR": "در قسمت زیر می توانید عنوان و متن پیام پوش نوتیفیکیشن را مدیریت کنید. همچنین برای ارسال نوتیفیکیشن، بر روی دکمه -ارسال نوتیفیکیشن- کلیک نمایید.",
    "en-US": ""
  },
  {
    "Key": "PushNotification_Body",
    "fa-IR": "متن پیام",
    "en-US": ""
  },
  {
    "Key": "ProductGroupPage",
    "fa-IR": "صفحه جهت لیست محصولات",
    "en-US": "Page for product list"
  },
  {
    "Key": "ProductDetailPage",
    "fa-IR": "صفحه جهت جزئیات محصول",
    "en-US": "Page for product details"
  },
  {
    "Key": "ProductGroupTitle",
    "fa-IR": "گروه محصول",
    "en-US": "Product group"
  },
  {
    "Key": "SetPagesHelpNote_1",
    "fa-IR": "در صورتی که قصد دارید صفحات انتخاب شده برای گروه های دیگری نیز استفاده شوند، می توایند در درخت زیر، گروه های مورد نظر را نیز انتخاب کنید.",
    "en-US": "N/A"
  },
  {
    "Key": "MainProductGroup",
    "fa-IR": "گروه محصول اصلی",
    "en-US": "Main product group"
  },
  {
    "Key": "BelowTable",
    "fa-IR": "لیست پایین",
    "en-US": "Below table"
  },
  {
    "Key": "FromOrders",
    "fa-IR": "تمام سفارشات",
    "en-US": "From orders"
  },
  {
    "Key": "FromOrderDetails",
    "fa-IR": "جزئیات تمام سفارشات",
    "en-US": "From order details"
  },
  {
    "Key": "RegisteredProductCount",
    "fa-IR": "تعداد محصول ثبت شده",
    "en-US": "Registered product count"
  },
  {
    "Key": "ExternalLink",
    "fa-IR": "لینک خارجی محصول",
    "en-US": "External link"
  },
  {
    "Key": "TabHeaderWidth",
    "fa-IR": "عرض هدر",
    "en-US": "Tab header width"
  },
  {
    "Key": "ChangingDisplayOrder",
    "fa-IR": "تغییر ترتیب نمایش",
    "en-US": "Changing display order"
  },
  {
    "Key": "ProductDetailTabs",
    "fa-IR": "تب های صفحه جزئیات",
    "en-US": "Product detail tabs"
  },
  {
    "Key": "Icons",
    "fa-IR": "آیکون ها",
    "en-US": "Icons"
  },
  {
    "Key": "CommentTitle",
    "fa-IR": "عنوان نظر",
    "en-US": "Comment title"
  },
  {
    "Key": "RateParams",
    "fa-IR": "گزینه های امتیاز",
    "en-US": "Rate params"
  },
  {
    "Key": "DefaultRate",
    "fa-IR": "امتیاز پیش فرض",
    "en-US": "Default rate"
  },
  {
    "Key": "License",
    "fa-IR": "لایسنس",
    "en-US": "License"
  },
  {
    "Key": "ProductLicenses",
    "fa-IR": "لایسنس محصولات",
    "en-US": "Product licenses"
  },
  {
    "Key": "LinkToOrderDetails",
    "fa-IR": "لینک به جزئیات سفارش",
    "en-US": "Link to order details"
  },
  {
    "Key": "Supplier",
    "fa-IR": "تامین کننده",
    "en-US": "Supplier"
  },
  {
    "Key": "MultiplePage",
    "fa-IR": "تنظیم صفحات",
    "en-US": "Multiple page"
  },
  {
    "Key": "PriceLayerGroup",
    "fa-IR": "گروه لایه قیمتی",
    "en-US": "Price layer group"
  },
  {
    "Key": "PriceLayerUnits",
    "fa-IR": "واحد لایه قیمتی",
    "en-US": "Price layer units"
  },
  {
    "Key": "Ratio",
    "fa-IR": "نسبت به پایه",
    "en-US": "Ratio"
  },
  {
    "Key": "PriceLayers",
    "fa-IR": "لایه قیمتی",
    "en-US": "Price layers"
  },
  {
    "Key": "ExtraInfo",
    "fa-IR": "محصولات دیگر",
    "en-US": "Extra info"
  },
  {
    "Key": "Text",
    "fa-IR": "متن",
    "en-US": "Text"
  },
  {
    "Key": "Color",
    "fa-IR": "رنگ",
    "en-US": "Color"
  },
  {
    "Key": "Tag",
    "fa-IR": "برچسب",
    "en-US": "Tag"
  },
  {
    "Key": "Required",
    "fa-IR": "الزامی",
    "en-US": "Required"
  },
  {
    "Key": "Reports",
    "fa-IR": "گزارشات",
    "en-US": "Reports"
  },
  {
    "Key": "Financial",
    "fa-IR": "مالی",
    "en-US": "Financial"
  },
  {
    "Key": "ProformaInvoice",
    "fa-IR": "پیش فاکتور",
    "en-US": "ProformaInvoice"
  },
  {
    "Key": "ProductsList",
    "fa-IR": "لیست محصولات",
    "en-US": "Products list"
  },
  {
    "Key": "ManagementForm",
    "fa-IR": "فرم مدیریت",
    "en-US": "Management form"
  },
  {
    "Key": "Tags",
    "fa-IR": "برچسب ها",
    "en-US": "Tags"
  },
  {
    "Key": "Marketer",
    "fa-IR": "بازاریاب",
    "en-US": "Marketer"
  },
  {
    "Key": "Special",
    "fa-IR": "ویژه",
    "en-US": "Special"
  },
  {
    "Key": "PriceLayer",
    "fa-IR": "لایه بندی قیمت",
    "en-US": "Price Layers"
  },
  {
    "Key": "Location",
    "fa-IR": "مکان سکونت",
    "en-US": "Location"
  },
  {
    "Key": "CustomTags",
    "fa-IR": "تگ سفارشی",
    "en-US": "Custom Tag"
  },
  {
    "Key": "Gifts",
    "fa-IR": "هدایا",
    "en-US": "Gifts"
  },
  {
    "Key": "Units",
    "fa-IR": "واحدها",
    "en-US": "Units"
  },
  {
    "Key": "Type",
    "fa-IR": "نوع",
    "en-US": "Type"
  },
  {
    "Key": "SectionType",
    "fa-IR": "بخش",
    "en-US": "Section"
  },
  {
    "Key": "DynamicLinks",
    "fa-IR": "لینک های پویا",
    "en-US": "Dynamic Links"
  },
  {
    "Key": "DynamicContents",
    "fa-IR": "محتوای پویا",
    "en-US": "Dynamic Contents"
  },
  {
    "Key": "SellreSearchTitle",
    "fa-IR": "فقط نمایش محصولات ثبت شده توسط فروشندگان",
    "en-US": "Just Show Seller's Product"
  },
  {
    "Key": "Stock",
    "fa-IR": "انبارها",
    "en-US": "Stock"
  },
  {
    "Key": "ProductBarcode",
    "fa-IR": "بارکد محصول",
    "en-US": "ProductBarcode"
  },
  {
    "Key": "UserRoles",
    "fa-IR": "نقش های کاربر",
    "en-US": "UserRoles"
  },
  {
    "Key": "EditByExcel",
    "fa-IR": "به روز رسانی از طریق اکسل",
    "en-US": "Edit By Excel"
  },
  {
    "Key": "Help",
    "fa-IR": "راهنما",
    "en-US": "Help"
  },
  {
    "Key": "ProductInfoHelp1",
    "fa-IR": "با استفاده از این فرم می توانید محصول به سیستم اضافه و یا محصولی را ویرایش کنید",
    "en-US": "Help1"
  },
  {
    "Key": "ProductInfoHelp2",
    "fa-IR": "سایز مناسب برای تصویر محصول (عرض * ارتفاع) : 700 * 700 پیکسل",
    "en-US": "Help2"
  },
  {
    "Key": "AdminStatus",
    "fa-IR": "وضعیت تایید مدیر",
    "en-US": "Admin Approval Status"
  },
]


export const errorMessages = {
  InvalidPhoneNumber: {
    values: {
      fa_IR: "شماره موبایل وارد شده صحیح نمیباشد",
      en_US: "The phone number is invalid"
    }
  },
  InvalidNationalCode: {
    values: {
      fa_IR: "کدملی وارد شده صحیح نمیباشد",
      en_US: "The national code is invalid"
    }
  }
}